import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import theme, { MEDIA_SMALL } from 'styles/theme';

import Logo from 'components/Logo';
import UserNav from 'components/UserNav';

const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  position: relative;
  background: ${theme.B300};
  color: ${theme.font_primary};
  grid-area: Header;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
  z-index: 3;

  .Header__left {
    display: flex;
    align-items: stretch;
    flex: 1 1 auto;
    margin-right: 15px;
  }

  .Header__actions {
    display: flex;
    align-items: stretch;
  }

  .Header__logo {
    padding: 0 20px;
  }

  .Header__right {
    position: relative;
    display: flex;
    flex: 0 0 auto;
    align-items: stretch;
    justify-content: flex-end;
    margin-left: auto;

    .User__photo {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
    }
  }

  a,
  .Header__item {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    padding: 20px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px;
    color: ${theme.font_primary};
    cursor: pointer;
    text-decoration: none;
    transition: background 300ms;

    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }

  .Header__item {
    cursor: default;

    &:hover {
      background: transparent;
    }
  }

  .Header__icon {
    font-size: 18px;
  }

  @media (max-width: ${MEDIA_SMALL}) {
    flex-flow: column nowrap;

    .Header__left {
      flex-flow: column nowrap;
      margin: 0;
    }

    .Header__logo {
      display: flex;
      justify-content: center;
      padding: 15px 20px;
    }

    .Header__actions {
      flex-flow: column;
    }

    a,
    .Header__item {
      display: flex;
      flex: 1 1 auto;
      text-align: center;
    }

    .Header__right {
      margin-left: 0;
    }

    .Header__icon {
      justify-content: center;
    }
  }
`;

const Header = ({ showHelp }) => (
  <StyledHeader>
    <div className="Header__left">
      <Link className="Header__logo" to="/">
        <Logo />
      </Link>
      <div className="Header__actions">
        <Link to="/">Home</Link>
        <Link to="/debts">Debts</Link>
        <a onClick={showHelp}>Help</a>
      </div>
    </div>
    <div className="Header__right">
      <UserNav />
    </div>
  </StyledHeader>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js